export default "__VITE_ASSET__DTcYo63t__"